import { LowerCasePipe } from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { BrowserModule, HammerModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
// import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';

import { MomentModule } from 'angular2-moment';
import { NgxWebstorageModule } from 'ngx-webstorage';
import { MaintenancePageComponent } from './maintenance-page/maintenance-page.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginLayoutComponent } from './layouts/login-layout/login-layout.component';
import { MainLayoutModule } from './layouts/main-layout/main-layout.module';
import { AuthExpiredInterceptor } from './shared/interceptors/auth-expired.interceptor';
import { AuthInterceptor } from './shared/interceptors/auth.interceptor';
import { ErrorHandlerInterceptor } from './shared/interceptors/errorhandler.interceptor';
import { SharedModule } from './shared/shared.module';
import { StoreModule } from '@ngrx/store';
import { reducers, metaReducers } from './reducers';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { EffectsModule } from '@ngrx/effects';
import { NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import {
  NgxGoogleAnalyticsModule,
  NgxGoogleAnalyticsRouterModule,
} from 'ngx-google-analytics';

// AoT requires an exported function for factories
// export function HttpLoaderFactory(httpClient: HttpClient) {
//   return new TranslateHttpLoader(httpClient, './assets/i18n/', '.json');
// }
export function createTranslateLoader(http: HttpClient) {
  return new MultiTranslateHttpLoader(http, [
    { prefix: './assets/i18n/', suffix: '.json' }, //host app i18n assets
    { prefix: './socx-proposals/assets/i18n/', suffix: '.json' }, //your lib assets
    { prefix: './socx-member-users/assets/i18n/', suffix: '.json' },
    { prefix: './socx-proposal-image-uploads/assets/i18n/', suffix: '.json' },
    { prefix: './socx-promotions/assets/i18n/', suffix: '.json' },
  ]);
}
@NgModule({
  declarations: [AppComponent, LoginLayoutComponent, MaintenancePageComponent],
  imports: [
    BrowserModule,
    NgbTypeaheadModule,
    HammerModule,
    AppRoutingModule,
    HttpClientModule,
    FlexLayoutModule,
    BrowserAnimationsModule,
    MainLayoutModule,
    MomentModule,
    NgIdleKeepaliveModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
      isolate: true,
    }),
    SharedModule.forRoot(),
    NgxGoogleAnalyticsModule.forRoot(environment.GA_TRACKINGID),
    NgxGoogleAnalyticsRouterModule,
    NgxWebstorageModule.forRoot({ prefix: 'socx-admin', separator: '-' }),
    StoreModule.forRoot({}, {}),
    StoreModule.forRoot(reducers, {
      metaReducers,
    }),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: environment.production,
    }),
    StoreRouterConnectingModule.forRoot(),
    EffectsModule.forRoot([]),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthExpiredInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorHandlerInterceptor,
      multi: true,
    },
    LowerCasePipe,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
